<template>
  <div id="app">
    <Header></Header>
    <div class="shareWrap hideShare" v-if="type==1">
      <ShareBtn></ShareBtn>
    </div>
    <router-view/>
    <Footer></Footer>
    <!-- <qq v-if="type==2"></qq> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      // 1代表PC，2代表移动端
      type:1,
    }
  },
  created(){
    // 判断当前设备
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    this.type = flag?2:1
  },
}
</script>

<style lang="less" scoped>
#app{
  .shareWrap{
    position: fixed;
    top: 40%;
    z-index: 9999;
  }
}
.fixPadding{
  padding-top: 1.28rem;
}
.hideShare{
  display: block;
}
@media screen and (max-width: 1040px){
  .hideShare{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue